import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckIcon, XIcon } from 'lucide-react';
const forWho = ['Profesionales que trabajan frente a pantallas y sufren por las luces fluorescentes.', 'Padres y madres que necesitan estar presentes y alertas a pesar del dolor.', 'Personas que quieren reducir su dependencia de fármacos agresivos.', 'Inmigrantes en USA que enfrentan altos niveles de estrés y jornadas intensas.'];
const notForWho = ["Personas que buscan una 'cura milagrosa' de una sola vez sin aplicar el método.", 'Quienes prefieren seguir tomando fármacos sin intentar alternativas físicas.', 'Casos médicos graves que requieren intervención quirúrgica inmediata.'];
export function WhoIsFor() {
  return <section className="py-20 px-6 bg-navy-900" data-id="element-190">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-191">
        <FadeIn direction="right" data-id="element-192">
          <div className="bg-navy-800 p-8 rounded-2xl border border-teal-500/20 h-full" data-id="element-193">
            <h3 className="font-serif text-2xl font-bold mb-6 text-white flex items-center" data-id="element-194">
              <span className="bg-teal-500/20 p-2 rounded-lg mr-3" data-id="element-195">
                <CheckIcon className="w-6 h-6 text-teal-400" data-id="element-196" />
              </span>
              Para Quién Es
            </h3>
            <ul className="space-y-4" data-id="element-197">
              {forWho.map((item, i) => <li key={i} className="flex items-start" data-id="element-198">
                  <CheckIcon className="w-5 h-5 text-teal-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-199" />
                  <span className="text-slate-300" data-id="element-200">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn direction="left" delay={0.2} data-id="element-201">
          <div className="bg-navy-800 p-8 rounded-2xl border border-red-500/20 h-full" data-id="element-202">
            <h3 className="font-serif text-2xl font-bold mb-6 text-white flex items-center" data-id="element-203">
              <span className="bg-red-500/10 p-2 rounded-lg mr-3" data-id="element-204">
                <XIcon className="w-6 h-6 text-red-500" data-id="element-205" />
              </span>
              Para Quién NO Es
            </h3>
            <ul className="space-y-4" data-id="element-206">
              {notForWho.map((item, i) => <li key={i} className="flex items-start" data-id="element-207">
                  <XIcon className="w-5 h-5 text-red-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-208" />
                  <span className="text-slate-300" data-id="element-209">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}